module.exports = __webpack_public_path__ + "static/media/factual.fcec9d53.png";